export default __webpack_public_path__ + "static/media/avatar_33.6b652943.png";